import "../settings/SettingsPageContainer.scss";

import React from "react";

type ReferralSettingsContainerPropTypes = {
  header?: React.ReactNode;
  children?: React.ReactNode;
};

const ReferralSettingsPageContainer = ({
  header,
  children,
}: ReferralSettingsContainerPropTypes) => {
  return (
    <div className="SettingsPageContainer">
      {header && <div className="SettingsPageContainer__Header">{header}</div>}
      {children}
    </div>
  );
};

export default ReferralSettingsPageContainer;
